// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectCertificationQueryResult, selectCertificationsPageLoading, selectCertificationsShowInitWaitingMessage} from '../_selectors/certification.selectors';

export class CertificationsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectCertificationsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectCertificationsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectCertificationQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
